<template>
    <div class="regist">
        <div class="login-header">
        	<div class="login-brand">
        		<img :src="logoImg" class="logo" />
        	</div>
        </div>
        <div class="resigt_cent">
            <h1 class="role">选择注册类型</h1>
            <div class="resigt_from">
                <el-form status-icon
                        class="resigt_froms"
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm">
                    <el-form-item class="resigt_froms_btns" prop="resource">
                        <el-radio-group v-model="ruleForm.resource" @change="agreeChange">
                            <el-radio :label="1" border>
                                个人用户
                            </el-radio>
                            <el-radio :label="2" border>
                                企业用户
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="resigt_froms_btn">
                        <el-button type="primary" @click="dataFormSubmit('ruleForm','userType')" id="xia">下一步</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="login-footer">
        	<p>{{ $t("login.copyright") }}2020 ©</p>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
	  logoImg: require('../../assets/img/logo.png'), // icon
      ruleForm: {
        resource: 1
      },
      rules: {
        resource: [
          { required: true, message: '请选择注册类型', trigger: 'change' }
        ]
      },
      userType: ''
    }
  },
  created () {
    this.$store.state.userType = this.ruleForm.resource
  },
  methods: {
    closeDialog () {
      this.dataForm.type = true
      this.dialogVisible = false
    },
    agreeChange (val) {
      console.log(val)
      this.$store.state.userType = val
    },
    // 表单提交
    dataFormSubmit (formName, userType) {
      console.log(this.$store.state.userType)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({ path: '/registpage', query: { userType: this.$store.state.userType } })
        } else {
          return false
        }
      })
    }

  }
}
</script>

<style scoped lang='scss'>
    .regist {
    	width: 100%;
    	height: 100vh;
    	margin: 0 auto;
		background: #F3F4F5;
    	overflow-y: auto;
    }

    .regist .login-header {
    	width: 100%;
    	height: 100px;
		background: #fff;
		position: relative;
    }

    .regist .login-header .login-brand {
		width: 1200px;
		position: absolute;
		left: 50%;
		margin-left: -600px;
    }

    .logo {
		width: 180px;
		height: 50px;
		margin-top: 26px;
    }

    .login-footer {
    	width: 460px;
    	position: absolute;
    	bottom: 0;left: 50%;
    	padding: 20px;
    	color: rgba(255, 255, 255, 0.6);
    	margin-left: -230px;
    	p {
    		height: 16px;
    		margin: 10px 0;
    		text-align: center;
    	}
    }
    .role {
        font-size: 20px;
        color: #539be3;
        line-height: 40px;
        padding: 10px 20px;
        margin: 0;
        border-bottom: 1px solid #eee;
    }

    .resigt_title {
        font-size: 1.6rem;
        font-weight: bold;
        line-height: 40px;
        padding: 20px 40px 0;
        color: #fff;
    }

    .resigt_title img {
        width: 64px;
        margin-right: 10px;
    }

    .resigt_cent {
        width: 1200px;
        margin: 30px auto 10px;
        padding: 0 40px;
        background: #fff;
        overflow: hidden;
        clear: both;
    }

    .regist_left {
        padding: 20px 0;
        text-align: center;
        display: flex;
        clear: both;
    }

    .resigt_from {
        display: flex;
        justify-content: center;
        padding: 20px 40px;
        box-sizing: border-box;
    }
    .resigt_froms {
      flex-direction: column;
      display: flex;
      justify-content:space-between
    }
    .resigt_froms_btns {
      display: flex;
      justify-content: space-between;
    }

    .resigt_froms_btn {
       display: flex;
       justify-content: center;
    }
    .resigt_from .el-form-item {
        flex: 1;
    }

    .list_menu {
        display: flex;
    }

    .list_menu .list_item {
        width: 200px;
        align-items: center;
        text-decoration: none;
        border: 1px solid #eee;
        display: flex;
        padding: 8px;
        margin: 8px;
        cursor: pointer;
        border-radius: 5px;
    }

    .list_item_icon {
        width: 40px;
        height: 40px;
        text-align: center;
        border-radius: 100%;
        margin: 0 10px;
        color: #999;
        /* background: #eee; */
        overflow: hidden;
    }

    .list_item_icon i {
        display: block;
        /*    margin-top: 10px; */
    }

    .list_item_icon i:last-child {
        font-size: 34px;
    }

    .list_item_text {
        flex: 1;
        margin-top: 10px;
        flex-direction: column;
        padding: 0;
        text-align: left;
        line-height: 0.8;
    }

    .list_item_text p {
        font-size: 12px;
        color: #999;
    }

    .regist_cent {
        width: 80%;
        float: left;
    }

    .tavActive {
        background: #63c9bf;
        color: #fff;
    }

    .tavActive i,
    .tavActive p {
        color: #fff;
    }
</style>
